import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import { FileCode2 } from 'lucide-react';
import { createGame } from '../lib/store';
import { extractTitle } from '../lib/analyze';

export default function ImportDialog({ open, onOpenChange, onCreated }) {
  const [code, setCode] = useState('');
  const [title, setTitle] = useState('');
  const [genre, setGenre] = useState('Arcade');
  const [fileName, setFileName] = useState('');

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const txt = await f.text();
    setCode(txt); setFileName(f.name);
    if (!title) setTitle(extractTitle(txt, f.name.replace(/\.\w+$/, '')));
  };
  const submit = async () => {
    if (code.trim().length < 20) return toast.error('Codice troppo corto o mancante');
    const g = await createGame({ title: title || extractTitle(code), genre, code, label: 'Importato' });
    toast.success('Gioco importato nel Vault');
    setCode(''); setTitle(''); setFileName('');
    onOpenChange(false);
    onCreated(g);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="import-dialog" className="bg-titan-surface border-violet-500/30 max-w-xl">
        <DialogHeader>
          <DialogTitle>Importa gioco esistente</DialogTitle>
          <DialogDescription className="t-chat">Carica un file .html/.js o incolla il codice. THE ARCHITECT potrà poi farne il reverse engineering e moddarlo.</DialogDescription>
        </DialogHeader>
        <Tabs defaultValue="file">
          <TabsList className="grid grid-cols-2 w-full">
            <TabsTrigger data-testid="import-tab-file" value="file">File</TabsTrigger>
            <TabsTrigger data-testid="import-tab-paste" value="paste">Incolla codice</TabsTrigger>
          </TabsList>
          <TabsContent value="file">
            <label className="mt-3 flex flex-col items-center justify-center gap-2 h-32 rounded-xl border border-dashed border-cyan-500/40 cursor-pointer hover:bg-cyan-500/5 transition-colors">
              <FileCode2 className="h-6 w-6 text-cyan-300" />
              <span className="text-xs text-slate-300">{fileName || 'Tocca per scegliere .html / .htm / .js'}</span>
              <input data-testid="import-file-input" type="file" accept=".html,.htm,.js,.txt,text/html" className="hidden" onChange={onFile} />
            </label>
          </TabsContent>
          <TabsContent value="paste">
            <Textarea data-testid="import-code-textarea" value={code} onChange={(e) => setCode(e.target.value)} placeholder="<!DOCTYPE html> ... oppure solo JavaScript" className="mt-3 h-40 font-mono text-xs" />
          </TabsContent>
        </Tabs>
        <div className="grid grid-cols-2 gap-3">
          <Input data-testid="import-title-input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Titolo" />
          <Input data-testid="import-genre-input" value={genre} onChange={(e) => setGenre(e.target.value)} placeholder="Genere" />
        </div>
        <button data-testid="import-submit-btn" onClick={submit} className="rounded-lg py-2.5 text-sm font-bold bg-violet-600 hover:bg-violet-500 transition-colors">Importa nel Vault</button>
      </DialogContent>
    </Dialog>
  );
}
